import axios from 'axios';

const httpClient = axios.create({
    // baseURL: 'https://api.mes4-dev.tatamotors.com',
    // baseURL: 'https://api.esakha-pv-dev.tatamotors.com',
});

export { httpClient }


